// colors
import { colors } from '../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  container: {
    padding: 16,
    display: 'flex',
    borderBottom: `1px solid ${colors.neutral100}`,
    justifyContent: 'space-between',
  },
  btnBack: {
    border: 'none',
    backgroundColor: colors.primary100,
    width: 40,
    height: 40,
    padding: 0,
    minWidth: 0,
    marginRight: 12,
  },
  info: {
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: 12,
  },
  title: {
    margin: 0,
    fontSize: 18,
  },
  subtitle: {
    fontSize: 14,
    color: colors.neutral600,
  },
  btnMarkNoShow: {
    marginLeft: 'auto',
    backgroundColor: colors.destructive50,
    color: colors.destructive600,
    '&:hover': {
      backgroundColor: colors.destructive100,
    },
  },
  menu: {
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  menuItemsWrapper: {
    '& .MuiPaper-root': {
      borderRadius: 8,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      minWidth: 200,
    },
  },
});
